import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m9.8178 21.817h4.3669c-.11594.15466-.24891.29766-.39703.42604-.49606.42953-1.1302.66589-1.7864.66589-.65618 0-1.2904-.23636-1.7864-.66589-.1482-.12838-.2811-.27137-.39711-.42604zm2.1834-20.726h.000109c2.1274 4.36e-5 4.1709.8287 5.6976 2.3103 1.5229 1.4779 2.4118 3.4895 2.4796 5.61v1.352h.0043v3.5985l.07384.19033 1.5409 3.9709c.00011.000436.000328.000872.000436.0013.0076.02006.01276.03829.01615.05541l.0051.07995c-.0049.06773-.03218.13209-.07798.18281-.04636.05137-.10864.08531-.17648.09664l-.07538.0035h-19.006c-.047054 0-.093476-.0108-.13563-.03174-.042178-.02084-.078958-.05116-.10748-.08857-.028522-.03741-.048013-.08093-.056958-.12707-.00767-.0396-.0074-.08028.000709-.11965l.024323-.07188 1.5358-3.9521.074061-.19066v-4.6875c-.0001308-1.0746.21143-2.1387.6226-3.1315.41116-.9928 1.0139-1.8949 1.7737-2.6547.75983-.75983 1.6619-1.3625 2.6547-1.7737.9928-.41116 2.0569-.62272 3.1315-.6226z",
		stroke: "currentColor",
		strokeWidth: 2.1815
	})]
});
const ForwardRef = forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
